import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Appliances & White Goods Parts',
    image: '/images/junk-waste/junk-appliances.png',
  },
  {
    title: 'Metal Furniture & Frames',
    image: '/images/junk-waste/junk-metal-furniture.png',
  },
  {
    title: 'Mixed Metal Scrap',
    image: '/images/junk-waste/junk-mixed-metal.png',
  },
  {
    title: 'General Scrap Metal',
    image: '/images/junk-waste/junk-general-scrap.png',
  },
  {
    title: 'Pipes & Metal Offcuts',
    image: '/images/junk-waste/junk-pipes-offcuts.png',
  },
  {
    title: 'Bins, Frames & Clearance Metal',
    image: '/images/junk-waste/junk-bins-frames.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what metal needs clearing from the job.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around your clearance schedule.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Mixed metal and clearance leftovers leave through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your crew stays on clearances while scrap metal is moved on properly.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep clearances tidy with accountable routes for metal streams.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and free up van space by moving metal the smart way.',
  },
  {
    title: 'Better for the environment',
    body: 'Metals are recovered for reuse instead of sitting in mixed waste loads.',
  },
  {
    title: 'Built for clearance crews',
    body: 'Share access notes and photos so collectors arrive ready for bulky scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Move metal loads faster' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function JunkWasteRemovalPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="jw-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="jw-hero-heading">
              Scrap collection for <span>junk & waste removal companies</span>
            </h1>
            <p className="kf-lead">
              Clear mixed metal from house clearances and commercial jobs quickly and responsibly —
              so your next load stays efficient and compliant.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-junk-waste.png"
              alt="Junk and waste removal scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for clearance crews — appliances, frames, mixed metal and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="jw-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="jw-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from house clearances, commercial strip-outs and van loads</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="jw-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="jw-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clearer load plan</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="jw-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="jw-why-heading">Why junk & waste companies choose SnapScrap</h2>
            <p>Clear metal faster, keep vans moving, and handle scrap the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your clearance scrap for free today</h2>
            <p>
              List metal from your next junk or waste removal job and get matched with a licensed
              collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
